// Update this version number each time you make changes to the UI
// Format: YYYY.MM.DD.sequence (e.g., 2025.10.22.1, 2025.10.22.2, etc.)
export const APP_VERSION = '2025.10.24.1'
